import $ from 'jquery';

const mobileMenuSearchTrigger = () => {
    const $searchTrigger = $('.c-mobile-menu-search-trigger');
    const $menuTrigger = $('.c-mobile-nav-trigger');
    const $mobileMenu = $('.mobile-menu');
    const $mobileSearchInput = $('.c-mobile-search .editing-form-value-cell input:last');
    const activeClass = 'is-active';

    if ($searchTrigger.length) {
        $searchTrigger.on('click', () => {
            if (!$mobileMenu.hasClass(activeClass)) {
                $menuTrigger.click();
            }
            $mobileSearchInput.focus();
        });
    }
};

// doc ready
$(() => {
    mobileMenuSearchTrigger();
});
